import { Plus, Pencil, Trash2, X, ImagePlus, Calendar, ArrowLeft, Check, Link } from "lucide-react";
import { useNavigate } from "react-router";
const API = "";

function ListView({ posts, onCreate, onEdit, confirmDeleteId, setConfirmDeleteId, onDelete, formatDate }) {
    const navigate = useNavigate()

    return (
        <div>
            <div className="ppa-header">
                <div>
                    <h1 className="ppa-title">Фотосессии</h1>
                    <p className="ppa-subtitle">
                        {posts.length === 0 ? "Пока нет ни одной страницы" : `Страниц: ${posts.length}`}
                    </p>
                </div>
                <button onClick={onCreate} className="ppa-btn ppa-btn-primary">
                    <Plus size={16} strokeWidth={2.5} />
                    Новая страница
                </button>
            </div>

            {posts.length === 0 ? (
                <div className="ppa-empty">
                    <ImagePlus size={32} className="ppa-empty-icon" />
                    <p className="ppa-empty-text">Создайте первую страницу фотосессии</p>
                </div>
            ) : (
                <div className="ppa-grid">
                    {posts.map((post) => (
                        <div key={post.id} className="ppa-card">
                            <div className="ppa-card-thumb">
                                {post.images[0] ? (
                                    <img src={API + post.images[0].url} alt={post.title} className="ppa-card-img" />
                                ) : (
                                    <div className="ppa-card-placeholder">
                                        <ImagePlus size={28} />
                                    </div>
                                )}
                                {post.images.length > 1 && (
                                    <span className="ppa-card-count">+{post.images.length - 1}</span>
                                )}
                            </div>

                            <div className="ppa-card-body">
                                <h3 className="ppa-card-name">{post.title || "Без названия"}</h3>
                                <div className="ppa-card-date">
                                    <Calendar size={12} />
                                    {formatDate(post.shootDate)}
                                </div>
                            </div>

                            <div className="ppa-card-actions">
                                <button onClick={() => onEdit(post)} className="ppa-icon-btn" title="Редактировать">
                                    <Pencil size={14} />
                                </button>
                                <button onClick={() => navigate('/gallery/' + post.id)} className="ppa-icon-btn" title="Редактировать">
                                    <Link size={14} />
                                </button>
                                <button
                                    onClick={() => setConfirmDeleteId(post.id)}
                                    className="ppa-icon-btn ppa-icon-btn-danger"
                                    title="Удалить"
                                >
                                    <Trash2 size={14} />
                                </button>
                            </div>

                            {confirmDeleteId === post.id && (
                                <div className="ppa-confirm-overlay">
                                    <p className="ppa-confirm-text">Удалить «{post.title || "Без названия"}»?</p>
                                    <div className="ppa-confirm-actions">
                                        <button onClick={() => onDelete(post.id)} className="ppa-btn ppa-btn-danger ppa-btn-sm">
                                            Удалить
                                        </button>
                                        <button onClick={() => setConfirmDeleteId(null)} className="ppa-btn ppa-btn-ghost ppa-btn-sm">
                                            Отмена
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
export default ListView